
import { defineComponent, createVNode } from 'vue';
import { mapState } from 'vuex';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import numeral from 'numeral';
import Banner from '@/components/banner/Banner.vue';
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import { getOrderDetail, getInternaion, copyOrder } from '@/api/apis';
import { downloadFile } from '@/api/request';
import { baseUrl } from '@/utils/constants';
import { baseFileUrl } from '@/utils/constants';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';

interface VehicleOrderDetailProps {
  detail: any;
  previewImg: any[];
  [key: string]: any;
}

export default defineComponent({
  name: 'VehicleOrderDetail',
  components: {
    Banner,
    BackArrowIcon,
    DownloadIcon,
    PreviewImageModal
  },
  created() {
    const id = +(this.$route.params.id as string);
    if (!isNaN(id) && id > 0) {
      this.id = id;
      this.loadData();
    }
  },
  data(): VehicleOrderDetailProps {
    return {
      previewImg: [],
      showAttributeImgModal: false,
      moment,
      numeral,
      id: 0,
      loading: false,
      colTitle: [
        'model',
        'color',
        'unit',
        'quantity',
        'unit_price',
        'total_price',
        'remark'
      ],
      columns: [
        {
          dataIndex: 'model',
          width: 120,
          slots: { customRender: 'model', title: 'model-title' }
        },
        {
          dataIndex: 'color',
          width: 100,
          slots: { customRender: 'color', title: 'color-title' }
        },
        {
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit', title: 'unit-title' }
        },
        {
          dataIndex: 'totalQuantity',
          width: 100,
          slots: { title: 'quantity-title' }
        },
        {
          dataIndex: 'sellingPrice',
          width: 100,
          slots: { customRender: 'unitPrice', title: 'unit_price-title' }
        },
        {
          dataIndex: 'totalPrice',
          width: 100,
          slots: { customRender: 'totalPrice', title: 'total_price-title' }
        },
        {
          width: 120,
          dataIndex: 'remark',
          slots: { title: 'remark-title' }
        }
      ],
      dataSource: [],
      detail: {},
      moneyTypes: [],
      isCopying: false
    };
  },
  methods: {
    handleAfterImgModalClose() {
      this.previewImg = [];
      this.showAttributeImgModal = false;
    },
    handleShowAttrImg(record) {
      this.previewImg.push(
        record.attributeImg ? `${baseFileUrl}${record.attributeImg}` : ''
      );
      this.showAttributeImgModal = true;
    },
    getTotalPrice() {
      const res = numeral(0);

      this.detail.offSellingPrice
        ? res.add(this.detail.offSellingPrice || 0)
        : res.add(this.detail.totalSellingPrice || 0);
      const currency = this.getCurrency(this.detail);

      const value = res.value();
      return value ? currency + res.format('0,0.00') : '';
    },
    async handleDownload() {
      const paramArr: string[] = [];

      paramArr.push(`customerId=${this.userInfo.id}`);
      paramArr.push(`locale=${this.lang}`);
      const moneyType = this.detail.moneyType
        ? this.$t(this.detail.moneyType)
        : '';
      if (moneyType) {
        paramArr.push(`moneyType=${moneyType}`);
      }

      await downloadFile(
        `${baseUrl}ureport/excel?_u=db:user_vehicle_order_detail_export.ureport.xml&orderId=${
          this.id
        }&${paramArr.join('&')}`,
        this.$t('order.order_title') + '.xlsx',
        null
      );
    },
    getCurrency(record) {
      let res = '';
      const moneyType = record.moneyType;

      if (moneyType) {
        const item: any = this.moneyTypes.find(
          (s: any) => s.code === moneyType
        );

        res = item ? item.val : '';
      }
      return res;
    },
    getOrderStatus(status) {
      let res = '';

      if (!isNaN(status) && status !== null && status >= 0) {
        res = this.$t(`order_status.${status}`);
      }
      return res;
    },
    async loadData() {
      this.loading = true;

      const dRes = await getInternaion({ type: 8 });

      if (dRes.success) {
        this.moneyTypes = dRes.result || [];
      }

      const res = await getOrderDetail({
        id: this.id
      });

      if (res.success) {
        this.detail = res.result || {};

        this.dataSource = this.detail.orderDetailList || [];
      }

      this.loading = false;
    },
    handleBack() {
      this.$router.push('/order?tab=1');
    },
    handleReorder() {
      Modal.confirm({
        // title: 'Are you sure delete this task?',
        icon: createVNode(ExclamationCircleOutlined),
        content: this.$t('shopping_cart.reorder_confirm'),
        okText: this.$t('shopping_cart.confirm'),
        cancelText: this.$t('shopping_cart.cancel'),
        onOk: async () => {
          if (this.id > 0) {
            this.isCopying = true;
            const res = await copyOrder({
              id: this.id
            });

            if (res.success) {
              this.handleBack();
            }

            this.isCopying = false;
          }
        }
      });
    }
  },
  computed: {
    ...mapState(['lang', 'userInfo']),
    totalSummary(): string {
      let res = numeral(0);

      this.dataSource.forEach(d => {
        res = res.add(d.totalPrice || 0);
      });

      const moneyIcon = '$';

      const value = res.value();

      return value ? moneyIcon + res.format('0,0.00') : '';
    }
  }
});
